module.exports = __webpack_public_path__ + "img/bg08.c2dd414e.png";